define('modules/editor/views/property_boxes/page_defaults',['require','exports','module','./base','fontmanager','ldsh!../../templates/property_boxes/page_defaults'],function(require, exports, module){
  "use strict";
  var BasePropertyGroup = require("./base"),
      FontManager = require("fontmanager");

  module.exports = BasePropertyGroup.extend({
    template: require("ldsh!../../templates/property_boxes/page_defaults"),
    helpers: function() {
      return {
        fonts: FontManager.getNames()
      };
    }
  });
});

